import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core';
import { ListComponentGeneric } from '../../../ui/generics';
import { IArticleVariant } from '../../../core/interfaces';
import { NotificationService } from '../../../core/services';
import { ArticlesServiceErrorResolverService } from '../core/error-resolvers/articles-service-error-resolver.service';
import { environment } from '../../../../environments/environment';
import { ArticlesVariantsService } from '../core/ArticlesVariantsService';
import { FilterOperator } from '../../../core/types';
import * as moment from 'moment';

@Component({
    selector: 'app-mhd-list',
    templateUrl: './mhd-list.component.html',
    styleUrl: './mhd-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MhdListComponent extends ListComponentGeneric<IArticleVariant> implements OnInit {

  public selectedDate: string;
  public showEmptyMhd = false;
  public selectedOperator: FilterOperator = 'eq';
  public readonly dateFormat = environment.defaultDateFormat;
  public readonly operators: { label: string; value: FilterOperator; }[] = [
    { label: '<', value: 'lt' },
    { label: '<=', value: 'le' },
    { label: '=', value: 'eq' },
    { label: '>', value: 'gt' },
    { label: '>=', value: 'ge' },
  ];

  constructor(
    protected _service: ArticlesVariantsService,
    protected _cdr: ChangeDetectorRef,
    protected _notify: NotificationService,
    protected renderer: Renderer2,
    protected _errorResolver: ArticlesServiceErrorResolverService,
  ) {
    super(_service, _cdr, _notify, renderer, _errorResolver);
  }

  searchColumns = [];

  protected readonly exportedTableVisibleName = 'MHD-Liste';

  public showEmptyMhdChange(): void {
    if (this.showEmptyMhd) {
      this.selectedDate = null;
      this.selectedOperator = 'eq';
    }

    this.onRefreshList();
  }

  load(
    pageIndex: number,
    pageSize: number,
    sortField: string | null,
    sortOrder: string | null,
    filter: { key: string; value: string[]; operator?: FilterOperator; }[],
    search: { key: string; value: string[] }[],
    additionalFilters: { key: string; value: string[]; operator?: FilterOperator; }[] = [],
  ): void {
    if (this.selectedDate) {
      filter.push(
        { key: 'mhd', value: [moment(this.selectedDate).format('YYYY-MM-DD')], operator: this.selectedOperator ?? 'eq' }
      );
    } else {
      filter.push({ key: 'mhd', value: ['null'], operator: this.showEmptyMhd ? 'eq' : 'ne' });
    }

    additionalFilters.push({ key: 'onlyMhd', value: ['true'] });

    super.load(pageIndex, pageSize, sortField, sortOrder, filter, search, additionalFilters);
  }
}
